import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { useQuery, useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { LOPDAOTAOLIENTUC_TRIENKHAI_API, LICHHOCLIENTUC_API } from '../../../../utils/apiUrl';
import { Get, Post } from '../../../../utils/httpProvider';

const BoSungHocVienModal = ({ show, onHide, lopId, ngay, onSuccess }) => {
    const [selectedHocVienId, setSelectedHocVienId] = useState('');
    const [selectedGiangVienId, setSelectedGiangVienId] = useState('');
    const [lyDo, setLyDo] = useState('');
    const [ghiChu, setGhiChu] = useState('');

    // 1. Fetch danh sách học viên trong lớp
    const { data: hocViens = [] } = useQuery(
        ['studentsInClassForBoSung', lopId],
        () => Get(`${LOPDAOTAOLIENTUC_TRIENKHAI_API.GET_HOCVIENS}/${lopId}`),
        { enabled: show && !!lopId, select: (res) => res?.$values || res || [] }
    );

    // 2. Fetch danh sách giảng viên trong lớp
    const { data: giangViens = [] } = useQuery(
        ['giangViensInClassForBoSung', lopId],
        () => Get(`${LOPDAOTAOLIENTUC_TRIENKHAI_API.GET_GIANGVIENS}/${lopId}`),
        { enabled: show && !!lopId, select: (res) => res?.$values || res || [] }
    );

    // 3. Mutation bổ sung ngoài lịch
    const boSungMutation = useMutation(
        (payload) => Post(LICHHOCLIENTUC_API.BO_SUNG_HOC_VIEN, null, payload),
        {
            onSuccess: () => {
                toast.success("Bổ sung học viên điểm danh thành công!");
                onHide();
                setSelectedHocVienId('');
                setSelectedGiangVienId('');
                setLyDo('');
                setGhiChu('');
                if (onSuccess) onSuccess();
            },
            onError: () => toast.error("Lỗi khi bổ sung học viên ngoài lịch!")
        }
    );

    const handleSubmit = () => {
        if (!selectedHocVienId) {
            toast.warning("Vui lòng chọn học viên!");
            return;
        }

        boSungMutation.mutate({
            lopDaoTaoLienTucId: lopId,
            hoSoTuyenSinhId: selectedHocVienId,
            giangVienThucTeId: selectedGiangVienId || "00000000-0000-0000-0000-000000000000",
            ngayThucTe: ngay,
            lyDoDieuPhoi: lyDo,
            ghiChu: ghiChu
        });
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title className="h6 font-weight-bold text-primary">
                    <i className="fas fa-user-plus mr-2"></i>
                    Bổ Sung Học Viên Ngoài Lịch / Học Bù
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Group>
                    <Form.Label className="font-weight-bold">Chọn học viên cần bổ sung:</Form.Label>
                    <Form.Control
                        as="select"
                        value={selectedHocVienId}
                        onChange={(e) => setSelectedHocVienId(e.target.value)}
                    >
                        <option value="">-- Chọn học viên trong lớp --</option>
                        {hocViens.map(hv => (
                            <option key={hv.id} value={hv.id}>
                                {hv.hoTen} ({hv.soDienThoai || hv.soCccd || "Học viên"})
                            </option>
                        ))}
                    </Form.Control>
                </Form.Group>

                <Form.Group>
                    <Form.Label className="font-weight-bold">Giảng viên hướng dẫn / chấm:</Form.Label>
                    <Form.Control
                        as="select"
                        value={selectedGiangVienId}
                        onChange={(e) => setSelectedGiangVienId(e.target.value)}
                    >
                        <option value="">-- Chọn giảng viên (tùy chọn) --</option>
                        {giangViens.map(gv => (
                            <option key={gv.id} value={gv.id}>
                                {gv.fullName} ({gv.pseudonym || "Giảng viên"})
                            </option>
                        ))}
                    </Form.Control>
                </Form.Group>

                <Form.Group>
                    <Form.Label className="font-weight-bold">Lý do điều phối / học bù:</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Ví dụ: Học bù buổi ngày..., Đổi lịch khoa phòng..."
                        value={lyDo}
                        onChange={(e) => setLyDo(e.target.value)}
                    />
                </Form.Group>

                <Form.Group>
                    <Form.Label>Ghi chú thêm:</Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={2}
                        value={ghiChu}
                        onChange={(e) => setGhiChu(e.target.value)}
                    />
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>Hủy</Button>
                <Button
                    variant="primary"
                    disabled={!selectedHocVienId || boSungMutation.isLoading}
                    onClick={handleSubmit}
                >
                    {boSungMutation.isLoading ? "Đang lưu..." : "Xác nhận bổ sung"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default BoSungHocVienModal;
